// extracted by mini-css-extract-plugin
export default {"button-border":"TagList_button-border__FMBY7","button-border-no-children":"TagList_button-border-no-children__uhJJk","input":"TagList_input__eegsN"};